export default class AgentTransactionInfoForDate {

    constructor(jsonObj) {

        this.transactionCount = jsonObj["transaction-count"];
        this.transactionSum = jsonObj["transaction-sum"];

    }

}